import React, { useState } from 'react';
import { SVG_EYE, SVG_EYE_SLASH, SVG_LOCK, SVG_UNLOCK } from '../../../Assets/SVG/svg_util';


const Password = ({ label, value, onValueChange, onFocus, onBlur, placeholder, name, style, required = false }) => {
  const [showPassword, setShowPassword] = useState(false);
  
  const [error, setError] = useState('');
  const togglePassword = () => { setShowPassword(!showPassword) }
  const handleChange = (e) => {

    // setValue(e.target.value);
    setError(''); // Clear any previous error
    onValueChange(e.target.name, e.target.value);
  };
  return (
    <div className="w-full mx-auto">
      {label && (
        <div className="py-1">
          <label className="text-start  font-[400] text-[14px]">
            {label}
          </label>
        </div>
      )}
      <div className='relative flex items-center '>
        <span className="absolute left-3">
          <SVG_LOCK />
        </span>
        <input
          className={`w-full p-2 pl-10 rounded-md outline-none border-2 !bg-[#7ddbff] !bg-opacity-[30%] text-sm ${value ? 'bg-gray-200' : ''}`}
          placeholder={placeholder}
          name={name}
          type={showPassword ? "text" : "password"}
          value={value || ''}
          style={{  ...style }}
          onFocus={(e) => {
            e.target.classList.add("border-[#7ddbff]")
            onFocus && onFocus(e);
          }}
          onBlur={(e) => {
            e.target.classList.remove("border-[#7ddbff]")
            required && !value &&   setError('Field Required');
            onBlur && onBlur(e);
          }}
          onChange={handleChange}
        />
        <span className="absolute right-3 cursor-pointer" onClick={togglePassword}>
          {showPassword ? <SVG_EYE /> : <SVG_EYE_SLASH />}
        </span>
      </div>
      <div className="text-red-500 text-xs mt-1 h-4 text-start px-2">{error}</div>
    </div>
  );
}

export default Password;
